module.exports = __webpack_public_path__ + "img/new-afiliados.bafbb94f.svg";